import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify"; 
import { useNavigate } from "react-router-dom";
import {
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { submitStripePayment } from "../utils/PaymentApi";
import { getUserProfileDetail } from "../utils/customerApi";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY); 

const ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: "16px",
      color: "#32325d",
      "::placeholder": {
        color: "#a0aec0",
      },
      padding: "10px",
    },
    invalid: {
      color: "#fa755a",
    },
  },
};

const PaymentForm = ({selectedPlan,selectedAppSlug,userDetail,zipCode,country}) => {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
      e.preventDefault();
      if (name.trim() === "") {
        toast.error("Name on card is required");
        return;
      }
    
      if (!stripe || !elements) {
        toast.error("Stripe is not loaded properly.");
        return;
      }

      const cardNumber = elements.getElement(CardNumberElement);
      const cardExpiry = elements.getElement(CardExpiryElement);
      const cardCvc = elements.getElement(CardCvcElement);

      if (!cardNumber._complete) {
        toast.error("Card number is incomplete");
        return;
      }
      if (!cardExpiry._complete) {
        toast.error("Expiry date is incomplete");
        return;
      }
      if (!cardCvc._complete) {
        toast.error("CVC is incomplete");
        return;
      }

      setLoading(true);

    try {
      const card = elements.getElement(CardNumberElement);
      const { paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card,
        billing_details: {
          name: name,
          email: userDetail.email,
          address: {
            line1: "123 MG Road",
            city: "Bangalore",
            state: "KA",
            postal_code: zipCode,
            country: "IN",
          }
        },
      });

      const payload = {
          plan_id: selectedPlan.id,
          plan_name: selectedPlan.name,
          plan_type: selectedPlan.plan_type,
          amount: selectedPlan.price,
          payment_method_id: paymentMethod.id,
          billing_details: {
              name: name,
              email: userDetail.email,
              address: {
                line1: "123 MG Road",
                city: "Bangalore",
                state: "KA",
                postal_code: zipCode,
                country: "IN",
              }
          }
      };
      
      const api_response = await submitStripePayment(payload);

      if (api_response.status === true) {
        //Call get User profile data for local storage
        const result = await getUserProfileDetail();
        if (result && result.data) {
          // Update session storage with new email
          sessionStorage.setItem("user_detail", JSON.stringify(result.data));
        }
        
        toast.success(api_response.message || "Payment successful!");
        setTimeout(() => {
          navigate(selectedAppSlug);
        }, 2000);
      } else {
        toast.error(api_response.message || "Payment failed.");
      }
    } catch (err) {
      toast.error("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: "420px", margin: "0 auto" }}>
      <h2>Payment</h2>
      <div className="input-group mb-0">
        <label>Name on Card</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={inputStyle}
        />
      </div>

      <div className="input-group payment-field">
        <label>Card Number</label>
        <div style={elementContainerStyle}>
          <CardNumberElement options={ELEMENT_OPTIONS} style={inputStyle} />
        </div>
      </div>

      <div className="input-row" style={{ display: "flex", gap: "1rem" }}>
        <div className="input-group payment-field">
          <label>Expiry</label>
          <div style={elementContainerStyle}>
            <CardExpiryElement options={ELEMENT_OPTIONS} style={inputStyle} />
          </div>
        </div>
        <div className="input-group payment-field">
          <label>CVC</label>
          <div style={elementContainerStyle}>
            <CardCvcElement options={ELEMENT_OPTIONS} style={inputStyle} />
          </div>
        </div>
      </div>

      <button type="submit" className="subscribe-btn" disabled={!stripe || loading}>{loading ? "Processing..." : `Pay now`}</button>
      <ToastContainer />
    </form>
  );
};

const StripePaymentForm = ({ selectedPlan,selectedAppSlug,userDetail,zipCode,country }) => {
  return (
    <Elements stripe={stripePromise}>
      <PaymentForm selectedPlan={selectedPlan} selectedAppSlug={selectedAppSlug} userDetail={userDetail} zipCode={zipCode} country={country} /> 
    </Elements>
  );
};

export default StripePaymentForm;

// Styles
const inputStyle = {
  padding: "10px",
  width: "100%",
  border: "1px solid #ccc",
  borderRadius: "4px",
  marginBottom: "1rem",
};

const elementContainerStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  backgroundColor: "white",
};
